import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
import { EMPTY_ARRAY } from '@base-ui/utils/empty';
import { schedulerEventSelectors } from "./schedulerEventSelectors.mjs";
import { schedulerResourceSelectors } from "./schedulerResourceSelectors.mjs";
import { getOccurrencesFromEvents } from "../internals/utils/event-utils.mjs";
import { schedulerOtherSelectors } from "./schedulerOtherSelectors.mjs";
const occurrencesGroupedByResourceListSelector = createSelectorMemoized(state => state.adapter, schedulerEventSelectors.processedEventList, schedulerResourceSelectors.visibleMap, schedulerResourceSelectors.processedResourceList, schedulerResourceSelectors.processedResourceChildrenLookup, schedulerOtherSelectors.displayTimezone, state => state.recurringEventsPlugin, (adapter, events, visibleResources, resources, resourcesChildrenMap, displayTimezone, recurringEventsPlugin, start, end) => {
  const occurrencesGroupedByResource = new Map();
  const occurrences = getOccurrencesFromEvents({
    adapter,
    start,
    end,
    events,
    visibleResources,
    displayTimezone,
    recurringEventsPlugin
  });
  for (const occurrence of occurrences) {
    const resourceId = occurrence.resource;
    if (resourceId) {
      if (!occurrencesGroupedByResource.has(resourceId)) {
        occurrencesGroupedByResource.set(resourceId, []);
      }
      occurrencesGroupedByResource.get(resourceId).push(occurrence);
    }
  }
  const processResources = innerResources => {
    const sortedResources = innerResources.toSorted((a, b) => a.title.localeCompare(b.title));
    const result = [];
    for (const resource of sortedResources) {
      if (visibleResources[resource.id] === false) {
        continue;
      }
      result.push({
        resource,
        occurrences: occurrencesGroupedByResource.get(resource.id) ?? []
      });
      const children = resourcesChildrenMap.get(resource.id) ?? [];
      if (children.length > 0) {
        result.push(...processResources(children));
      }
    }
    return result;
  };
  return processResources(resources);
});
const occurrencesGroupedByResourceMapSelector = createSelectorMemoized(occurrencesGroupedByResourceListSelector, (groupedByResourceList, _start, _end) => {
  const map = new Map();
  for (const {
    resource,
    occurrences
  } of groupedByResourceList) {
    map.set(resource.id, occurrences);
  }
  return map;
});
export const schedulerOccurrenceSelectors = {
  isStarted: createSelector(state => state.adapter, state => state.nowUpdatedEveryMinute, (adapter, now, start) => {
    return adapter.isBefore(start.value, now) || adapter.isEqual(start.value, now);
  }),
  isEnded: createSelector(state => state.adapter, state => state.nowUpdatedEveryMinute, (adapter, now, end) => {
    return adapter.isBefore(end.value, now);
  }),
  groupedByResourceList: occurrencesGroupedByResourceListSelector,
  resourceOccurrences: createSelector(occurrencesGroupedByResourceMapSelector, (map, _start, end, resourceId) => map.get(resourceId) ?? EMPTY_ARRAY)
};